import React from "react";
import PasswordResetComponent from "../../Common/PasswordResetComponent";

const AdminPasswordSent = () => <PasswordResetComponent
  passwordPath={"/admin/new-password"}
/>;

export default AdminPasswordSent;
